import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/REGISTRATION';

export const {
    action: cancelChildMove,
    success: cancelChildMoveSuccess,
    failed: cancelChildMoveFailed,
} = createAction(`${domain}/CANCEL_CHILD_MOVE`, (childId: string) => ({childId}));

export const {action: setShowChildGroupMoveModal} = createAction(
    `${domain}/SET_SHOW_CHILD_GROUP_MOVE_MODAL`,
    (show: boolean) => ({
        show,
    }),
);

export const {action: setShowSettingMoveModal} = createAction(
    `${domain}/SET_SHOW_SETTING_MOVE_MODAL`,
    (show: boolean) => ({
        show,
    }),
);
